import type { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import {
  fetchTenantAccount,
  type TenantWithRegion,
} from "@/lib/utils/tenant-account";
import { TenantApi } from "@/openapi/generated";

export async function prefetchTenantGet(
  queryClient: QueryClient,
  tenantId: number,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching tenant");
  }

  const service = createAuthenticatedApi(TenantApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Tenant, tenantId],
    queryFn: () =>
      fetchTenantAccount(
        service,
        tenantId,
        queryClient.getQueryData<TenantWithRegion>([QueryKeys.Tenant, tenantId]),
      ),
  });

  return queryClient;
}
